import {
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Button,
  useDisclosure,
  Icon,
} from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { Plus } from 'lucide-react';
import { SiteForm } from './SiteForm';

export function SiteFormModal() {
  const { isOpen, onClose, onOpen } = useDisclosure();
  return (
    <>
      <Button
        size="sm"
        variant="solid"
        bg="bg.muted"
        color="fg.emphasis"
        colorScheme="gray"
        onClick={onOpen}
        leftIcon={<Icon as={Plus} />}
      >
        <Trans>Add new site</Trans>
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} size="xl" closeOnOverlayClick={false}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Trans>Add new site</Trans>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Box ml="auto">
              <SiteForm onClose={onClose} />
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
